import React, { useEffect, useMemo, useRef } from "react";
import { comparer } from "mobx";
export { observer } from "mobx-react";
function equals(a, b) {
    return comparer.structural(a, b);
}
export function useDeepCompareEffect(callback, dependencies) {
    var ref = useRef(dependencies);
    var signalRef = useRef(0);
    if (!equals(dependencies, ref.current)) {
        ref.current = dependencies;
        signalRef.current += 1;
    }
    return useEffect(callback, useMemo(function() {
        return ref.current;
    }, [
        signalRef.current
    ]));
}
export function useUpperVM(props, type) {
    if (!props.$$useVMStack) return null;
    var contexts = props.$$useVMStack();
    var i = contexts.length;
    while(--i > -1){
        var _contexts_i = contexts[i], $$type = _contexts_i.$$type, $$vm = _contexts_i.$$vm;
        if ($$type === type) {
            return $$vm;
        }
    }
    return null;
}
export function useConnectToUpper(props, field) {
    var $$TYPE = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "FORM";
    var $$upper = useUpperVM(props, $$TYPE);
    useDeepCompareEffect(function() {
        var // 绑定`VM value`映射到 `FORM VM value` 中
        _props_$$vm_$linkToUpper, _props_$$vm;
        (_props_$$vm = props.$$vm) === null || _props_$$vm === void 0 ? void 0 : (_props_$$vm_$linkToUpper = _props_$$vm.$linkToUpper) === null || _props_$$vm_$linkToUpper === void 0 ? void 0 : _props_$$vm_$linkToUpper.call(_props_$$vm, $$upper, field, props.defaultValue);
    }, [
        props.defaultValue
    ]);
    // 当前的组件并没有配置VM
    // 并且Field组件并不会接管 `value/onChange` 的情况
    // 或者不存在Field组件的情况
    // 比如: react-hook-form
    var onChange = React.useCallback(function(value) {
        $$upper.$updateForPureInput(field, value, props.defaultValue);
    }, []);
    // 当前的组件并没有配置VM
    // 并且Field组件会接管 `value/onChange` 的情况
    // 比如: antd:form | saas-ui-form
    React.useEffect(function() {
        if (!props.$$vm && $$upper) onChange(props.value);
    }, [
        props.defaultValue,
        props.value,
        props.$$vm,
        $$upper
    ]);
    return {
        $$upper: $$upper,
        onChange: onChange
    };
}
